


































































































































































































import { mapGetters, mapActions } from "vuex";
import PlaylistContentCard from "./PlaylistContentCard.vue";
import Schedule from "../classes/Schedule";
import { Container } from "vue-smooth-dnd";
import { date } from "quasar";
import { applyDrag } from "../utils/helpers";
import sharedMethods from "../sharedMethods";

export default {
  name: "PlaylistTabPanels",
  props: ["tab", "activePlaylist"],
  components: {
    PlaylistContentCard,
    Container,
  },
  data() {
    return {
      scheduleToEdit: new Schedule(this.activePlaylist),
      schedModal: false,
      currentPlaylistMediaForcast: [],
      error: "",
      warning: "",
      startTime: "00:00",
      stopTime: "23:59",
      mo: true,
      tu: true,
      we: true,
      th: true,
      fr: true,
      sa: true,
      su: true,
      schedDate: {
        from: date.formatDate(Date.now(), "DD.MM.YYYY"),
        to: date.formatDate(date.addToDate(Date.now(), { days: 7 }), "DD.MM.YYYY"),
      },
      schedDateSet: false,
      dropPlaceholderOptions: {
        className: "drop-preview",
        animationDuration: "150",
        showOnTop: true,
      },
    };
  },
  watch: {
    activePlaylist() {
      this.getPlaylistSchedule();
    },
    mo() {
      if (!this.mo && !this.tu && !this.we && !this.th && !this.fr && !this.sa && !this.su) {
        this.warning = "Caution: if no days are selected your playlist wont start playing.";
        this.startTime = "00:00";
        this.stopTime = "23:59";
      } else {
        this.warning = "";
      }
    },
  },
  computed: {
    ...mapGetters(["getMediaFilesForPlaylist", "allMediaFiles", "allToPlaylistAssignedDeviceIDs", "devicesForIds"]),
    allToPlaylistAssignedDevices() {
      if (this.activePlaylist) {
        const ids = this.allToPlaylistAssignedDeviceIDs(this.activePlaylist.ID);
        return this.devicesForIds(ids);
      } else {
        return [];
      }
    },
    startStopTimeValid() {
      const stopTimeDate = date.formatDate(
        date.subtractFromDate(date.extractDate(this.stopTime, "HH:mm"), {
          hours: 12,
        }),
        "HH:mm"
      );

      if (this.startTime === this.stopTime || this.startTime === stopTimeDate) {
        this.error = "Please set a different start and stop time";
        return false;
      } else {
        this.error = "";
        return true;
      }
    },
    selectAll: {
      get() {
        return this.mo && this.tu && this.we && this.th && this.fr && this.sa && this.su;
      },
      set(newVal) {
        if (newVal) {
          this.mo = this.tu = this.we = this.th = this.fr = this.sa = this.su = true;
        } else {
          this.mo = this.tu = this.we = this.th = this.fr = this.sa = this.su = false;
        }
      },
    },
    getTotalPlaylistDuration: function() {
      this.currentPlaylistMediaForcast = [];

      var totalPlaylistDuration = new Date(0);

      this.getMediaFilesForPlaylist(this.activePlaylist).forEach((e) => {
        for (var i = 0; i < this.allMediaFiles.length; i++) {
          if (this.allMediaFiles[i] && e && this.allMediaFiles[i].name === e.name && this.allMediaFiles[i].duration) {
            var temp = new Date(0);
            temp.setUTCSeconds(this.allMediaFiles[i].duration.split(":")[2]);
            temp.setUTCMinutes(this.allMediaFiles[i].duration.split(":")[1]);

            totalPlaylistDuration.setUTCSeconds(totalPlaylistDuration.getUTCSeconds() + temp.getSeconds());
            totalPlaylistDuration.setUTCMinutes(totalPlaylistDuration.getUTCMinutes() + temp.getMinutes());

            this.updatePlaylistForecastEntry(e.name, temp.getTime() / 1000);
          }
        }
      });

      this.currentPlaylistPlayedPerHour = Math.round(60 / (totalPlaylistDuration.getTime() / 60000));
      this.currentPlaylistDurationInSeconds = totalPlaylistDuration.getTime() / 1000;
      console.log(JSON.stringify(this.currentPlaylistMediaForcast));

      var resultString = "";
      resultString += this.getLeadingZeros(totalPlaylistDuration.getUTCHours()) + ":";
      resultString += this.getLeadingZeros(totalPlaylistDuration.getUTCMinutes()) + ":";

      resultString += this.getLeadingZeros(totalPlaylistDuration.getUTCSeconds());

      return resultString;
    },
  },
  created() {
    this.getPlaylistSchedule();
  },
  methods: {
    ...mapActions(["updatePlaylistSchedule", "deletePlaylistSchedule", "updatePlaylistContentV2", "fetchAllUserPlaylists", "removePlaylistFromDevice", "fetchPlaylistSchedules"]),
    removePLfromDevice(DeviceIDPLChange) {
      this.removePlaylistFromDevice({
        device: DeviceIDPLChange,
        playlist: this.activePlaylist.ID,
      }).then((response) => {
        this.fetchAllUserPlaylists().then(() => {
          sharedMethods.successNotify("Playlist removed");
        });
      });
    },
    getChildPayload(index) {
      return this.getMediaFilesForPlaylist(this.activePlaylist)[index];
    },
    setScheduleToEdit(schedule: Schedule) {
      // copy schedule to make it editable
      this.scheduleToEdit = schedule.clone();

      // set start date
      if (this.scheduleToEdit.StartDate) {
        this.schedDate.from = date.formatDate(date.extractDate(this.scheduleToEdit.StartDate, "YYYY-MM-DDTHH:mm:ss.SSSZ"), "DD.MM.YYYY");
      } else {
        this.schedDateSet = false;
      }

      // set stop date
      if (this.scheduleToEdit.StopDate) {
        this.schedDate.to = date.formatDate(date.extractDate(this.scheduleToEdit.StopDate, "YYYY-MM-DDTHH:mm:ss.SSSZ"), "DD.MM.YYYY");

        this.schedDateSet = true;
      } else {
        this.schedDateSet = false;
      }

      this.startTime = "00:00";
      this.stopTime = "23:59";

      // set default to false
      this.mo = this.tu = this.we = this.th = this.fr = this.sa = this.su = false;

      // set start time and checkboxes
      if (this.scheduleToEdit.MONTAGSTART != null) {
        this.startTime = this.scheduleToEdit.MONTAGSTART;
        this.mo = true;
      }
      if (this.scheduleToEdit.DIENSTAGSTART != null) {
        this.startTime = this.scheduleToEdit.DIENSTAGSTART;
        this.tu = true;
      }
      if (this.scheduleToEdit.MITTWOCHSTART != null) {
        this.startTime = this.scheduleToEdit.MITTWOCHSTART;
        this.we = true;
      }
      if (this.scheduleToEdit.DONNERSTAGSTART != null) {
        this.startTime = this.scheduleToEdit.DONNERSTAGSTART;
        this.th = true;
      }
      if (this.scheduleToEdit.FREITAGSTART != null) {
        this.startTime = this.scheduleToEdit.FREITAGSTART;
        this.fr = true;
      }
      if (this.scheduleToEdit.SAMSTAGSTART != null) {
        this.startTime = this.scheduleToEdit.SAMSTAGSTART;
        this.sa = true;
      }
      if (this.scheduleToEdit.SONNTAGSTART != null) {
        this.startTime = this.scheduleToEdit.SONNTAGSTART;
        this.su = true;
      }

      // set stop time
      if (this.scheduleToEdit.MONTAGSTOP != null) {
        this.stopTime = this.scheduleToEdit.MONTAGSTOP;
      }
      if (this.scheduleToEdit.DONNERSTAGSTOP != null) {
        this.stopTime = this.scheduleToEdit.DIENSTAGSTOP;
      }
      if (this.scheduleToEdit.MITTWOCHSTOP != null) {
        this.stopTime = this.scheduleToEdit.MITTWOCHSTOP;
      }
      if (this.scheduleToEdit.DONNERSTAGSTOP != null) {
        this.stopTime = this.scheduleToEdit.DONNERSTAGSTOP;
      }
      if (this.scheduleToEdit.FREITAGSTOP != null) {
        this.stopTime = this.scheduleToEdit.FREITAGSTOP;
      }
      if (this.scheduleToEdit.SAMSTAGSTOP != null) {
        this.stopTime = this.scheduleToEdit.SAMSTAGSTOP;
      }
      if (this.scheduleToEdit.SONNTAGSTOP != null) {
        this.stopTime = this.scheduleToEdit.SONNTAGSTOP;
      }
    },
    onDrop(dropResult) {
      console.log("onDrop", dropResult);

      const { removedIndex, addedIndex, payload } = dropResult;

      // get current media files
      var contentArr = this.getMediaFilesForPlaylist(this.activePlaylist);

      // add new media into current media files
      var tmp = applyDrag(contentArr, dropResult);

      // get only the content ids of the new playlist
      let contentIds = [];
      tmp.forEach((content) => {
        if (content) {
          if (content.contentGroup) {
            contentIds.push(content.contentGroupId);
          } else {
            contentIds.push(content.id);
          }
        }
      });

      if (addedIndex != null) {
        this.updatePlaylistContentV2({
          content: contentIds,
          playlistId: this.activePlaylist.ID,
        });
      }
    },
    updateSchedule() {
      if (!this.startTime || !this.stopTime) {
        this.selectAll = false;
      }

      if (this.mo) {
        this.scheduleToEdit.MONTAGSTART = this.startTime;
        this.scheduleToEdit.MONTAGSTOP = this.stopTime;
      } else {
        this.scheduleToEdit.setMondayNull();
      }

      if (this.tu) {
        this.scheduleToEdit.DIENSTAGSTART = this.startTime;
        this.scheduleToEdit.DIENSTAGSTOP = this.stopTime;
      } else {
        this.scheduleToEdit.setTuesdayNull();
      }

      if (this.we) {
        this.scheduleToEdit.MITTWOCHSTART = this.startTime;
        this.scheduleToEdit.MITTWOCHSTOP = this.stopTime;
      } else {
        this.scheduleToEdit.setWednessdayNull();
      }

      if (this.th) {
        this.scheduleToEdit.DONNERSTAGSTART = this.startTime;
        this.scheduleToEdit.DONNERSTAGSTOP = this.stopTime;
      } else {
        this.scheduleToEdit.setThursdayNull();
      }

      if (this.fr) {
        this.scheduleToEdit.FREITAGSTART = this.startTime;
        this.scheduleToEdit.FREITAGSTOP = this.stopTime;
      } else {
        this.scheduleToEdit.setFridayNull();
      }

      if (this.sa) {
        this.scheduleToEdit.SAMSTAGSTART = this.startTime;
        this.scheduleToEdit.SAMSTAGSTOP = this.stopTime;
      } else {
        this.scheduleToEdit.setSaturdayNull();
      }

      if (this.su) {
        this.scheduleToEdit.SONNTAGSTART = this.startTime;
        this.scheduleToEdit.SONNTAGSTOP = this.stopTime;
      } else {
        this.scheduleToEdit.setSundayNull();
      }

      let startDate = null;
      let endDate = null;
      if (this.schedDateSet) {
        startDate = date.extractDate(this.schedDate.from, "DD.MM.YYYY");
        endDate = date.extractDate(this.schedDate.to, "DD.MM.YYYY");

        startDate.setHours(startDate.getHours() + 2);
        endDate.setHours(endDate.getHours() + 2);
        startDate = startDate.toISOString();
        endDate = endDate.toISOString();
      }

      this.scheduleToEdit.StartDate = startDate;

      this.scheduleToEdit.StopDate = endDate;

      this.scheduleToEdit.PLID = this.activePlaylist.ID;

      try {
        this.updatePlaylistSchedule(this.scheduleToEdit.toObject()).then(() => {
          this.schedModal = false;
        });
      } catch (error) {
        console.log(error);
      }
    },
    getPlaylistSchedule() {
      if (this.activePlaylist) {
        try {
          // will be automatically committed
          this.fetchPlaylistSchedules(this.activePlaylist.ID);
        } catch (error) {
          console.error(error);
        }
      }
    },
    deleteSchedule(schedule) {
      try {
        const plinfo = {
          schedID: schedule.ID,
          plID: schedule.PLID,
        };

        this.deletePlaylistSchedule(plinfo);
      } catch (error) {
        console.log(error);
      }
    },
    clearscheddata() {
      this.scheduleToEdit.clear();
      this.schedModal = false;
      this.selectAll = true;
      this.schedDateSet = false;
      this.startTime = "";
      this.stopTime = "";

      (this.schedDate.from = date.formatDate(Date.now(), "DD.MM.YYYY")), (this.schedDate.to = date.formatDate(date.addToDate(Date.now(), { days: 7 }), "DD.MM.YYYY"));
    },
    getLeadingZeros(time) {
      if (time < 10) {
        return "0" + time;
      } else {
        return time;
      }
    },
    updatePlaylistForecastEntry(filename, fileDuration) {
      var existing = false;
      if (this.currentPlaylistMediaForcast.length < 1) {
        this.currentPlaylistMediaForcast.push({
          name: filename,
          duration: fileDuration,
          count: 1,
        });
        existing = true;
      } else {
        this.currentPlaylistMediaForcast.forEach((plEntry) => {
          if (plEntry.name == filename) {
            plEntry.count += 1;
            console.log("Update: " + filename + " to forecast. New Count: " + plEntry.count);
            existing = true;
          }
        });
      }

      if (!existing) {
        this.currentPlaylistMediaForcast.push({
          name: filename,
          duration: fileDuration,
          count: 1,
        });
      }
    },
  },
};
